import { gql } from '@apollo/client';

// Mutation to create a new tag
export const CREATE_TAG = gql`
  mutation CreateTags($name: String!, $colorCode: String!) {
    createTag(name: $name, colorCode: $colorCode) {
      status
      message
    }
  }
`;

// Mutation to assign or unassign a tag to/from an account
export const ASSIGN_OR_UNASSIGN_TAG_TO_ACCOUNT = gql`
  mutation AssignOrUnassignTagToAccount($truentityId: String!, $tagId: ID, $action: String!, $isStarred: Boolean) {
    assignOrUnassignTagToAccount(truentityId: $truentityId, tagId: $tagId, action: $action, isStarred: $isStarred) {
      status
      message
    }
  }
`;

// Query to get all available tags
export const GET_ALL_TAGS = gql`
  query GetAllTags($includeStarred: Boolean) {
    getAllTags(includeStarred: $includeStarred) {
      id
      name
      colorCode
      tagType
      identifier
    }
  }
`;

// Mutation to update an existing tag
export const UPDATE_TAG = gql`
  mutation UpdateTag($tagId: ID!, $name: String!, $colorCode: String!) {
    updateTag(tagId: $tagId, name: $name, colorCode: $colorCode) {
      status
      message
    }
  }
`;

// Mutation to delete a tag
export const DELETE_TAG = gql`
  mutation DeleteTag($tagId: ID!) {
    deleteTag(tagId: $tagId) {
      status
      message
    }
  }
`;

// Query to get tags assigned to a specific account
export const GET_ACCOUNT_TAGS = gql`
  query GetAccountTags($accountId: ID!) {
    getAccountTags(accountId: $accountId) {
      id
      name
      colorCode
      tagType
      identifier
    }
  }
`;

// Query to get tags for a specific account (new implementation)
export const GET_TAGS_FOR_ACCOUNT = gql`
  query GetTagsForAccount($truentityId: String!) {
    getTagsForAccount(truentityId: $truentityId) {
      id
      name
      colorCode
      tagType
      identifier
    }
  }
`;

// Query to get a tag by name
export const GET_TAG_BY_NAME = gql`
  query GetTagByName($tagName: String!) {
    getTagByName(tagName: $tagName) {
      id
      name
      colorCode
      tagType
      identifier
    }
  }
`;
